import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ClaveSOLFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
    return (
        <Form.Group>
            <Form.Label text='Clave SOL' htmlFor='input-claveSOL' md={4} alignRightAt='md' />
            <Col md={8}>
                <Field name='claveSOL'>
                    {({ field }) => (
                        <Form.InputText
                            {...field}
                            type='password'
                            isInvalid={iTouched && iError}
                            disabled={fIsSubmitting}
                            id='input-claveSOL'
                        />
                    )}
                </Field>
                {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
            </Col>
        </Form.Group>
    )
}

export default React.memo(ClaveSOLFormGroup)
